<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 18C6.4875 18 4.35938 17.1281 2.61562 15.3844C0.871875 13.6406 0 11.5125 0 9C0 6.4875 0.871875 4.35938 2.61562 2.61562C4.35938 0.871875 6.4875 0 9 0C10.2937 0 11.5313 0.267 12.7125 0.801C13.8938 1.335 14.9062 2.09925 15.75 3.09375V0H18V7.875H10.125V5.625H14.85C14.25 4.575 13.4299 3.75 12.3896 3.15C11.3494 2.55 10.2195 2.25 9 2.25C7.125 2.25 5.53125 2.90625 4.21875 4.21875C2.90625 5.53125 2.25 7.125 2.25 9C2.25 10.875 2.90625 12.4688 4.21875 13.7812C5.53125 15.0938 7.125 15.75 9 15.75C10.4438 15.75 11.7469 15.3375 12.9094 14.5125C14.0719 13.6875 14.8875 12.6 15.3562 11.25H17.7188C17.1938 13.2375 16.125 14.8594 14.5125 16.1156C12.9 17.3719 11.0625 18 9 18Z"
      fill="black"
      fill-opacity="0.4"
    />
  </svg>
</template>
